export const IS_TAURI =
  typeof window !== 'undefined' && typeof window.__TAURI__ !== 'undefined' && !!window.__TAURI__.core

export const APPLICATION_SUBPATH = import.meta.env.BASE_URL
export const APPLICATION_SUBPATH_WITH_FALLBACK = APPLICATION_SUBPATH || '/' // Used for hardcoded/template images

export const NEW_OBJECT_URL_VALUE = 'new'
export const SAP_MAPPING_URL_VALUE = 'sap'
export const GLOBAL_MODALS_SECTION_KEY = 'global-modals'

export type Writable<T> = {
  -readonly [P in keyof T]: T[P]
}

export enum OptimisticActions {
  Delete,
  Create,
  Update,
}

export interface SimpleFormOption {
  name: string
  value: string
}

export type SimpleFormOptions = Array<SimpleFormOption>

export type BSVariant = 'primary' | 'secondary' | 'danger' | 'warning' | 'success' | 'info' | 'white'

export enum BSVariantEnum {
  Primary = 'primary',
  Secondary = 'secondary',
  Danger = 'danger',
  Warning = 'warning',
  Success = 'success',
  Info = 'info',
  White = 'white',
}

export enum ColumnCellEnum {
  TextBold,
  TextMuted,
  BgSecondary,
  DataAsset,
  DataObjectType,
}

export type Tab = { label: string; id: string; containerClasses?: string }

export type BasicItem = { name: string; value: string }

export interface XLSXFields {
  [key: string]: string
}

export type LoadingSize = 'sm' | 'lg'

export const LOCAL_STORAGE_HOME_REGION_KEY = 'SAIFTY_HOME_FILTER_REGION'
export const LOCAL_STORAGE_HOME_LANGUAGE_KEY = 'SAIFTY_HOME_FILTER_LANGUAGE'
export const LOCAL_STORAGE_GENERATE_LABEL_DATAOBJECTS_KEY = 'SAIFTY_GENERATE_LABEL_DATAOBJECTS'

export type DocumentSourceType = 'approval' | 'dataobject'
